export const FREQUENCY_FILTER = {
	MONTH: 'm',
	YEAR: 'y',
	ALL: ''
};

export default FREQUENCY_FILTER;
